import React from 'react';
import {Link} from "@material-ui/core";

export function UserName(props) {
  return (
    <Link to={'/profileviewer/' + props.user_id}>
      {props.children}
    </Link>);
}
